export default __webpack_public_path__ + "static/media/stat-15-years.5a4c9373.svg";